export const tag_popular_list_en =["Spring/summer"	,
"Decorative"	,
"Wallpaper"	,
"Wrapping paper"	,
"Botanical"	,
"Artistic"	,
"Hand painted"	,
"Colourful"	,
"Autumn/winter"	,
"Contemporary"	,
"Watercolour"	,
"Modern"	,
"Graphic"	,
"Vector pattern"	,
"Digital"	,
"Graphic pattern"	,
"Leaves"	,
"Abstract flower"	,
"Summer"	,
"Art"	,
"Bloom"	,
"Big flowers"	,
"Layered"	,
"Blossom"	,
"Vintage"	,
"Romantic"	,
"Multicolor"	,
"Illustration"	,
"Graphic floral"	,
"Exotic"	,
"Fall/winter"	,
"Blue"	,
"Retro"	,
	
	
"Wild flowers"	,
"Pink"	,
"Shapes"	,
"Bold"	,
"Foliage"	,
"Brushstrokes"	,
"Lines"	,
"Plants"	,
"Bright"	,
"Playful"	,
"Pretty"	,
"Vibrant"	,
"Jungle"	,
"Resort"	,
"Fun"	,
"Green"	,
"High summer"	,
"Ornamental"	,
"Pastel"	,
"Flourish"	,
"Simple"	,
"Spring"	,
"Black and white"	,
"Black"	,
"Monochrome"	,
"Yellow"	,
"Painted"	,
"Cute"	,
"Red"	,
"Roses"	,
"Leopard"	,
"Dots"	,
"Folk"	,
"Detailed"	,
"Ditsy"	,
"Dark"	,
"Psychedelic"	,
"Palm"	,
"Girls"	,
"Minimal"	,
"Orange"	,
"White"	,
"Linear"	,
"Large scale"	,
"Brown"	,
"Purple"	,
"Autumn"	,
"Hawaiian"	,
"Blue and white"	,
"Spots"	,
"Paisley"	,
"Sketched"	,
"Tonal"	,
"African"	,
"Tie dye"	,
"Symmetrical"	,
	
"Bouquet"	,
"Doodle"	,
"Grey"	,
"Silhouette"	,
"Folkloric"	,
"Birds"	,
"Zig zag"	,
"Oriental"	,
"Fall"	,
"Motif"	,
"Circles"	,
"Dark blue"	,
"Patchwork"	,
"Waves"	,
"Cream"	,
"Grunge"	,
"Forest"	,
"1970s"	,
"Zebra"	,
"Modernism"	,
"Mosaic"	,
"Winter"	,
	
"Squares"	,
"Tiger"	,
"Ink"	,
"Optical"	,
	
"Petals"	,
"Fruit"	,
"Indian"	,
"Batik"	,
"1980s"	,
"Collage"	,
"Triangles"	,
"Coral"	,
"Distorted"	,
"Daisy"	,
"Small Scale"	,
"Blurred"	,
"Indigo"	,
"Marble"	,
"Aqua"	,
"Futuristic"	,
	
"Navy"	,
"Light"	,
"Violet"	,
"Naïve"	,
"Mixed media"	,
"Kaleidoscope"	,
"Lilac"	,
"Turquoise"	,
"Peony"	,
	
"Gold"	,
"Japanese"	,
"Meadow"	,
"Bandana"	,
	
"Swirls"	,
"Ikat"	,
"Butterflies"	,
"1990s"	,
"Photographic"	,
"Holiday"	,
"Neon"	,
"Street art"	,
"1960s"	,
"Dark green"	,
"Ocean"	,
"Impressionist"	,
"Scribble"	,
"Scarf"	,
"Magenta"	,
"Lily"	,
"Diamonds"	,
"Teal"	,
"Nordic"	,
"Moroccan"	,
"Stars"	,
"Damask"	,
"Trees"	,
"Hibiscus"	,
"Orchid"	,
"Graffiti"	,
"Mirrored"	,
"Baroque"	,
"Embroidery"	,
"Cartoon"	,
"Snake"	,
"Aztec"	,
	
"Architectural"	,
"Lace"	,
"Art Nouveau"	,
"Ombre"	,
"Poppy"	,
	
	
"Weave"	,
"Cyan"	,
"Nautical"	,
"Space"	,
"Landscape"	,
"Shibori"	,
"Galaxy"	,
"Chevron"	,
"Mandala"	,
"Kimono"	,
"Chinoiserie"	,
"Fuchsia"	,
"Foulard"	,
"Food"	,
"Christmas"	,
"Fish"	,
"Hearts"	,
"Iridescent"	,
"Spaced"	,
"Insects"	,
"Tulip"	,
"Stencil"	,
"Faded"	,
"Fern"	,
"Cat"	,
"Lemon"	,
"Feathers"	,
"1940s"	,
"Jacquard"	,
"Mexican"	,
"Tartan"	,
"Bauhaus"	,
	
	
"Pixel"	,
	
"Chains"	,
"Banana"	,
"Lavender"	,
"Clouds"	,
"Magnolia"	,
"3d"	,
"1950s"	,
"Punk"	,
"Cactus"	,
"Jewel"	,
"Parrot"	,
"Giraffe"	,
"Vegetables"	,
"Candy"	,
"People"	,
"Flamingos"	,
"Pineapple"	,
"Houndstooth"	,
	
"Gothic"	,
"Strawberry"	,
"Knit"	,
	
"Iris"	,
"Horses"	,
"Cherries"	,
"Gingham"	,
"Valentine"	,
"Letters"	,
"Sweets"	,
"Bamboo"	,
"Silver"	,
"Halloween"	,
"Summer Festival"	,
"Dog"	,
"Pansy"	,
"Apple"	,
"Moth"	,
"Starfish"	,
"Daffodil"	,
	
"Herringbone"	,
"Beetle"	,
"Elephant"	,
"Rabbit"	,
"Boats"	,
"Ice-cream"	,
"Skull"	,
"Whale"	,
"Drinks"	,
	
"Cars"	,
"Dolphin"	,
"Frogs"	,
"Numbers"	]